/* @flow */
import { Roles } from './defs';
import type { RoleList } from './defs';

// Roles that can see the Rush Asset Request Launch Points
export const rushAssetRequestFormPermissions: RoleList = [
  Roles.SYSTEM_ADMIN,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.USER,
];
